import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/date-picker/style";
import _DatePicker from "antd/es/date-picker";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from 'moment';
import classnames from 'classnames';
import { useRef, useState, useEffect, useContext } from 'react';
import Typography from '../typography';
import invariant from 'invariant';
import { CalendarOutlined } from 'iglooicon';
import './style/index';
import { LocaleContext } from '../locale';
import '../date-picker/style';

var CreateRangePickerFilter = function CreateRangePickerFilter(props) {
  var optionKey = props.optionKey,
      title = props.title,
      choosed = props.choosed,
      _props$disabledDate = props.disabledDate,
      disabledDate = _props$disabledDate === void 0 ? function () {
    return false;
  } : _props$disabledDate,
      _props$valueConfirm = props.valueConfirm,
      valueConfirm = _props$valueConfirm === void 0 ? function () {} : _props$valueConfirm,
      format = props.format,
      setRangeType = props.setRangeType,
      tiemRange = props.tiemRange,
      onFocus = props.onFocus,
      _props$dateRangeConfi = props.dateRangeConfig,
      dateRangeConfig = _props$dateRangeConfi === void 0 ? {} : _props$dateRangeConfi,
      _props$pickerOpenStat = props.pickerOpenStatus,
      pickerOpenStatus = _props$pickerOpenStat === void 0 ? false : _props$pickerOpenStat,
      onChange = props.onChange,
      setPickerOpenStatus = props.setPickerOpenStatus;
  var RangePicker = _DatePicker.RangePicker;

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var dateRangerContainerRef = useRef();
  var timeValueRef = useRef({
    startTime: null,
    endTime: null
  });

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      timeValue = _useState2[0],
      setTimeValue = _useState2[1];

  invariant(typeof disabledDate === 'function', 'disabledDate must be a function');

  function handleTimeChange(date, info) {
    setRangeType(-1);
    var range = info.range;

    if (range === 'start') {
      setTimeValue([date[0], undefined]);
      timeValueRef.current.startTime = date[0];
    } else {
      setTimeValue([undefined, date[1]]);
      timeValueRef.current.endTime = date[1];
    }
  }

  useEffect(function () {
    if (timeValueRef.current.startTime && timeValueRef.current.endTime) {
      setTimeValue([timeValueRef.current.startTime, timeValueRef.current.endTime]);
      valueConfirm({
        type: optionKey,
        value: [timeValueRef.current.startTime, timeValueRef.current.endTime]
      });
      typeof onChange === 'function' && onChange([timeValueRef.current.startTime, timeValueRef.current.endTime]);
      setPickerOpenStatus({
        type: optionKey,
        value: false
      }); // 处理antd的选择完还有高亮问题

      onFocus.focus();
      setTimeout(function () {
        timeValueRef.current = {
          startTime: null,
          endTime: null
        };
      }, 0);
    }
  }, [timeValueRef.current.startTime, timeValueRef.current.endTime]);
  useEffect(function () {
    setTimeValue(choosed);
  }, [choosed]);

  var rangeSeparate = _jsx("div", {
    className: "igloo-filter-date-picker-range-separate"
  });

  return _jsxs("div", {
    className: "igloo-form-filter-drop-down-container-content-group",
    children: [_jsxs("div", {
      className: "igloo-form-filter-drop-down-container-content-group-title",
      children: [_jsx(Typography, {
        level: "h4",
        className: "igloo-form-filter-range-picker-label",
        children: title
      }), _jsxs("div", {
        className: "igloo-form-filter-range-picker-container",
        children: [_jsx(RangePicker, {
          inputReadOnly: true,
          className: classnames('igloo-date-picker-container', {
            'igloo-date-picker-focus': pickerOpenStatus
          }),
          dropdownClassName: "igloo-date-picker-panel",
          separator: rangeSeparate,
          format: format,
          value: timeValue,
          allowClear: false,
          disabledDate: disabledDate,
          getPopupContainer: function getPopupContainer() {
            return dateRangerContainerRef.current;
          },
          onCalendarChange: function onCalendarChange(date, _, info) {
            return handleTimeChange(date, info);
          },
          open: pickerOpenStatus,
          onOpenChange: function onOpenChange(visible) {
            if (visible) {
              setPickerOpenStatus({
                type: optionKey,
                value: true
              });
            }
          },
          suffixIcon: pickerOpenStatus ? _jsx(CalendarOutlined, {
            style: {
              fontSize: '20px',
              color: '#666666',
              opacity: 0
            }
          }) : _jsx(CalendarOutlined, {
            style: {
              fontSize: '20px',
              color: '#666666'
            }
          }),
          panelRender: function panelRender(pa) {
            var customFinallyUse = dateRangeConfig.custom || [moment(), moment()];
            var customDisable = disabledDate(customFinallyUse[0]) || disabledDate(customFinallyUse[1]);
            var lastDayFinallyUse = dateRangeConfig.lastDay || [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')];
            var lastDayDisable = disabledDate(lastDayFinallyUse[0]) || disabledDate(lastDayFinallyUse[1]);
            var lastSevenDaysFinallyUse = dateRangeConfig.lastSevenDays || [moment().subtract(6, 'days'), moment()];
            var lastSevenDaysDisable = disabledDate(lastSevenDaysFinallyUse[0]) || disabledDate(lastSevenDaysFinallyUse[1]);
            var lastMonthFinallyUse = dateRangeConfig.lastMonth || [moment().subtract(1, 'months'), moment()];
            var lastMonthDisable = disabledDate(lastMonthFinallyUse[0]) || disabledDate(lastMonthFinallyUse[1]);
            var thisMonthFinallyUse = dateRangeConfig.thisMonth || [moment().startOf('month'), moment().endOf('month')];
            var thisMonthDisable = disabledDate(thisMonthFinallyUse[0]) || disabledDate(thisMonthFinallyUse[1]);
            return _jsxs("div", {
              children: [_jsxs("div", {
                className: "igloo-form-filter-date-picker-panel-top",
                children: [_jsx("div", {
                  className: customDisable ? 'igloo-form-filter-date-picker-top-diable' : '',
                  onClick: function onClick() {
                    if (customDisable) return;
                    setRangeType(0);
                    timeValueRef.current = {
                      startTime: customFinallyUse[0],
                      endTime: customFinallyUse[1]
                    };
                  },
                  children: _jsx(Typography, {
                    level: "h5",
                    className: "".concat(tiemRange === 0 ? 'igloo-form-filter-date-picker-panel-top-action' : ''),
                    children: formatMessage({
                      id: 'Custom'
                    })
                  })
                }), _jsx("div", {
                  className: lastDayDisable ? 'igloo-form-filter-date-picker-top-diable' : '',
                  onClick: function onClick() {
                    if (lastDayDisable) return;
                    setRangeType(1);
                    timeValueRef.current = {
                      startTime: lastDayFinallyUse[0],
                      endTime: lastDayFinallyUse[1]
                    };
                  },
                  children: _jsx(Typography, {
                    level: "h5",
                    className: "".concat(tiemRange === 1 ? 'igloo-form-filter-date-picker-panel-top-action' : ''),
                    children: formatMessage({
                      id: 'Last Day'
                    })
                  })
                }), _jsx("div", {
                  className: lastSevenDaysDisable ? 'igloo-form-filter-date-picker-top-diable' : '',
                  onClick: function onClick() {
                    if (lastSevenDaysDisable) return;
                    setRangeType(2);
                    timeValueRef.current = {
                      startTime: lastSevenDaysFinallyUse[0],
                      endTime: lastSevenDaysFinallyUse[1]
                    };
                  },
                  children: _jsx(Typography, {
                    level: "h5",
                    className: "".concat(tiemRange === 2 ? 'igloo-form-filter-date-picker-panel-top-action' : ''),
                    children: formatMessage({
                      id: 'Last 7 Days'
                    })
                  })
                }), _jsx("div", {
                  className: lastMonthDisable ? 'igloo-form-filter-date-picker-top-diable' : '',
                  onClick: function onClick() {
                    if (lastMonthDisable) return;
                    setRangeType(3);
                    timeValueRef.current = {
                      startTime: lastMonthFinallyUse[0],
                      endTime: lastMonthFinallyUse[1]
                    };
                  },
                  children: _jsx(Typography, {
                    level: "h5",
                    className: "".concat(tiemRange === 3 ? 'igloo-form-filter-date-picker-panel-top-action' : ''),
                    children: formatMessage({
                      id: 'Last Month'
                    })
                  })
                }), _jsx("div", {
                  className: thisMonthDisable ? 'igloo-form-filter-date-picker-top-diable' : '',
                  onClick: function onClick() {
                    if (thisMonthDisable) return;
                    setRangeType(4);
                    timeValueRef.current = {
                      startTime: thisMonthFinallyUse[0],
                      endTime: thisMonthFinallyUse[1]
                    };
                  },
                  children: _jsx(Typography, {
                    level: "h5",
                    className: "".concat(tiemRange === 4 ? 'igloo-form-filter-date-picker-panel-top-action' : ''),
                    children: formatMessage({
                      id: 'This Month'
                    })
                  })
                })]
              }), pa]
            });
          }
        }), pickerOpenStatus && _jsx("div", {
          className: "igloo-form-filter-range-icon",
          children: _jsx(CalendarOutlined, {
            style: {
              fontSize: '20px'
            },
            onClick: function onClick() {
              setPickerOpenStatus({
                type: optionKey,
                value: false
              }); // 如果是手动关闭 则保留 上一次传递的值 用来展示

              setTimeValue(choosed); // 处理高亮问题

              onFocus.focus();
            }
          })
        }), _jsx("div", {
          ref: dateRangerContainerRef,
          className: "igloo-form-fliter-drop-down-container-content-group-title-ranger-container"
        })]
      })]
    }), _jsx(_Divider, {
      style: {
        margin: '16px 0px'
      }
    })]
  }, optionKey);
};

export default CreateRangePickerFilter;